export const CHALLENGE_PAGE_POSTHOG_VARIANTS = ['control', 'test', 'clarity'] as const;
export type ChallengePagePostHogVariant = (typeof CHALLENGE_PAGE_POSTHOG_VARIANTS)[number];

export const CHALLENGE_CLARITY_HOME_EXPERIMENT = {
  name: 'challenge_page_original_vs_clarity_home_2026_09_22',
  featureFlag: 'challenge-page-original-vs-clarity-home-2026-09-22',
  posthogExperimentId: 466563,
  status: 'draft',
  // control = Rob's original page (A), test = Martin's Clarity Home page (B),
  // form_first = short copy with the whole form on the first phone screen (C,
  // Rob 2026-09-23). The PostHog flag needs a form_first variant before C gets
  // traffic; until then a form_first value can only come from a preview.
  posthogVariants: ['control', 'test', 'form_first'],
  primaryMetric: 'Confirmed challenge registration conversion',
} as const;

export type ChallengeClarityHomeVariant =
  (typeof CHALLENGE_CLARITY_HOME_EXPERIMENT.posthogVariants)[number];

export type ChallengeExperimentContext = {
  experiment_name: string;
  experiment_variant: ChallengeClarityHomeVariant;
  feature_flag: string;
  is_experiment_active: boolean;
  [key: `$feature/${string}`]: ChallengeClarityHomeVariant;
};

export const CHALLENGE_PAGE_EXPERIMENT = {
  name: 'challenge_page_control_refined_clarity_2026_08_31',
  featureFlag: 'challenge-page-control-refined-clarity-2026-08-31',
  posthogExperimentId: 459166,
  predecessorPosthogExperimentId: 445170,
  status: 'active',
  posthogVariants: CHALLENGE_PAGE_POSTHOG_VARIANTS,
  variants: {
    control: 'Current challenge page',
    test: 'Refined challenge page',
    clarity: 'Clarity-painted refined challenge page',
  },
  primaryMetric: 'Confirmed challenge registration conversion',
  secondaryMetrics: ['Challenge form submission conversion'],
} as const;
